let cachedConfigPromise = null;

export async function fetchAppConfig() {
  if (cachedConfigPromise) {
    return cachedConfigPromise;
  }

  cachedConfigPromise = (async () => {
    // 1. Try fetching from dynamic server (config.php on Apache/PHP)
    // 2. Fallback to /config.json (local / static)
    const urls = ["/config.php", "/config.json"];

    for (const url of urls) {
      try {
        const res = await fetch(url, { cache: "no-store" });
        if (!res.ok) continue;

        const text = await res.text();
        // Skip if response is raw PHP source text (during npm start) or HTML
        if (
          !text ||
          text.trim().startsWith("<?php") ||
          text.trim().startsWith("<!DOCTYPE")
        ) {
          continue;
        }

        const data = JSON.parse(text);
        if (data && typeof data === "object") {
          return data;
        }
      } catch (e) {
        // Continue to next fallback
      }
    }

    throw new Error("Unable to load domain configuration");
  })();

  return cachedConfigPromise;
}
